module.exports = __webpack_public_path__ + "img/MATCH1.4d8fe0a2.png";